export default __webpack_public_path__ + "media/zurb/img/ecommerce/browse-efd41f5b5ef26f3c04773f9064c7646d.png";